import axios from 'axios';

class Http {
	constructor() {
		this.instance = axios.create({
			baseURL: import.meta.env.VITE_BASE_URL,
			timeout: 10000,
			httpVersion: 2,
			// withCredentials: true,
			// headers: {
			//   "Access-Control-Request-Headers": "content-type",
			// },
			// headers: {
			//   "Content-Type": "application/x-www-form-urlencoded",
			//   // "api-token": "56dd0ee1-31e7-4501-b760-80ea8d2b2e74"
			// },
		});
		// this.instance.defaults.headers.common["Content-Type"] =
		//   "application/x-www-form-urlencoded";
	}

	// setLogout(logoutCallback) {
	// 	this.logoutCallback = logoutCallback;
	// }

	async get(url, args) {
		let res, data;

		try {
			res = await this.instance.get(url, { params: args });
			if (res?.data) {
				data = res.data;
			}
		} catch (err) {
			console.log(`get err ${url}:: `, err);
			data = {
				...res,
				errored: true,
			};
		}

		return data;
	}

	async post(url, args) {
		// console.log("bef");

		let res, data;

		try {
			res = await this.instance.post(url, args, {
				// headers: {
				//   "Content-Type": "multipart/form-data",
				// }
			});
			if (res?.data) {
				data = res.data;
			}
		} catch (err) {
			// console.log(`post err ${url}:: `, err);
			data = {
				...res,
				err,
				errored: true,
			};
		}

		return data;
	}

	async put(url, args) {
		let res, data;

		try {
			res = await this.instance.put(url, args, {
				// headers: {
				//   "Content-Type": "multipart/form-data",
				// }
			});
			if (res?.data) {
				data = res.data;
			}
		} catch (err) {
			// console.log(`post err ${url}:: `, err);
			data = {
				...res,
				err,
				errored: true,
			};
		}

		return data;
	}

	async patch(url, args) {
		let res, data;

		try {
			res = await this.instance.patch(url, args, {
				// headers: {
				//   "Content-Type": "multipart/form-data",
				// }
			});
			if (res?.data) {
				data = res.data;
			}
		} catch (err) {
			// console.log(`patch err ${url}:: `, err);
			data = {
				...res,
				err,
				errored: true,
			};
		}

		return data;
	}

	async delete(url, args) {
		let res, data;

		try {
			res = await this.instance.delete(url, args);
			if (res?.data) {
				data = res.data;
			}
		} catch (err) {
			console.log(`delete err ${url}:: `, err);
			data = {
				...res,
				err,
				errored: true,
			};
		}

		return data;
	}

	updateToken(token = '') {
		// console.log('updatetoken below ');
		// console.log(token);
		this.instance.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
	}
}

const http = new Http();

export default http;
